define('plugin/static-page/collection/StaticPageCollection',['require','lib/collection/BaseCollection','plugin/static-page/model/StaticPageModel'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var StaticPageModel = require('plugin/static-page/model/StaticPageModel');

    /**
     * Gallery collection
     *
     * @class SocialGalleryCollection
     */
    return BaseCollection.extend({
        url: '/static-page/list/',
        model: StaticPageModel,

        _getPageModel : function (id) {
            var model =  this.get(id);

            if (!model) {
                model = new StaticPageModel({id : id});
                model.fetch();
                this.add(model);
            }

            return model;
        },
        
        _getPageModelBySeoUrl : function (seoUrl) {
            var model = this.find(function (model) {
                return String(model.get('seo_url')).toLowerCase() === String(seoUrl).toLowerCase();
            });

            if (!model) {
                model = new StaticPageModel({
                    id : -1
                });
                model.fetch({ data: jQuery.param({ seo_url: seoUrl}) });
                this.add(model);
            }

            return model;
        }
    });

});
